module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.achievementObj) ? _c('div', {
    staticClass: "brand-achievement-wrapper"
  }, [_c('div', {
    staticClass: "box brand-achievement",
    class: _vm.isNew ? 'new-brand-achievement' : ''
  }, [(!_vm.isNew) ? _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBrandAchievement(_vm.achievement.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Заголовок"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.achievementObj.title),
      callback: function($$v) {
        _vm.$set(_vm.achievementObj, "title", $$v)
      },
      expression: "achievementObj.title"
    }
  })], 1), _vm._v(" "), _c('b-switch', {
    staticClass: "mt-10",
    model: {
      value: (_vm.achievementObj.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.achievementObj, "isHidden", $$v)
      },
      expression: "achievementObj.isHidden"
    }
  }, [_vm._v("Скрыть с сайта")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.imageSrc) ? _c('div', {
    staticClass: "link-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-danger delete-file",
    on: {
      "click": _vm.deleteFile
    }
  }, [_vm._v("Удалить изображение")])]) : _c('b-field', {
    staticClass: "mt-10"
  }, [_c('button', {
    staticClass: "button mt-10",
    on: {
      "click": function($event) {
        return _vm.$refs.loadReviewFile.click()
      }
    }
  }, [_vm._v("\n        Загрузить изображение\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "loadReviewFile",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadReviewFile
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary mt-10 save-button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb2cc02a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrandAchievementItem.vue
// module id = 996
// module chunks = 0